/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { i as isWeb, a as isKuaiShouMiniProgram, b as isWeChatMiniProgram, c as isByteDanceMicroApp, d as isMiniApp, e as isBaiduSmartProgram } from './index-892d8eee.js';

var getApp$7 = (function () {
  return getApp();
});

var getCurrentPages$6 = (function () {
  return getCurrentPages();
});

var getLaunchOptionsSync$6 = (function () {
  return my.getLaunchOptionsSync();
});

function isUndef(type) {
  return type === 'undefined';
}

var isDingdingMiniapp = !isUndef(typeof dd) && dd !== null && !isUndef(typeof dd.alert);

var onError$6 = (function (cb) {
  return isDingdingMiniapp ? dd.onError(cb) : my.onError(cb);
});

var offError$5 = (function (cb) {
  return isDingdingMiniapp ? dd.offError(cb) : my.offError(cb);
});

var onUnhandledRejection$6 = (function (cb) {
  return isDingdingMiniapp ? dd.onUnhandledRejection(cb) : my.onUnhandledRejection(cb);
});

var offUnhandledRejection$5 = (function (cb) {
  return isDingdingMiniapp ? dd.offUnhandledRejection(cb) : my.offUnhandledRejection(cb);
});

var aliMiniAppModule = {
  getApp: getApp$7,
  getCurrentPages: getCurrentPages$6,
  getLaunchOptionsSync: getLaunchOptionsSync$6,
  onError: onError$6,
  offError: offError$5,
  onUnhandledRejection: onUnhandledRejection$6,
  offUnhandledRejection: offUnhandledRejection$5
};

var getApp$6 = (function () {
  return getApp();
});

var getCurrentPages$5 = (function () {
  return getCurrentPages();
});

var getLaunchOptionsSync$5 = (function () {
  return wx.getLaunchOptionsSync();
});

var onError$5 = (function (cb) {
  return wx.onError(cb);
});

var offError$4 = (function (cb) {
  return wx.offError(cb);
});

var onUnhandledRejection$5 = (function (cb) {
  return wx.onUnhandledRejection(cb);
});

var offUnhandledRejection$4 = (function (cb) {
  return wx.offUnhandledRejection(cb);
});

var weChatModule = {
  getApp: getApp$6,
  getCurrentPages: getCurrentPages$5,
  getLaunchOptionsSync: getLaunchOptionsSync$5,
  onError: onError$5,
  offError: offError$4,
  onUnhandledRejection: onUnhandledRejection$5,
  offUnhandledRejection: offUnhandledRejection$4
};

var getApp$5 = (function () {
  return getApp();
});

var getCurrentPages$4 = (function () {
  return getCurrentPages();
});

var getLaunchOptionsSync$4 = (function () {
  return tt.getLaunchOptionsSync();
});

var onError$4 = (function (cb) {
  return tt.onError(cb);
});

var offError$3 = (function (cb) {
  return tt.offError(cb);
});

var onUnhandledRejection$4 = (function (cb) {
  return tt.onUnhandledRejection(cb);
});

var offUnhandledRejection$3 = (function (cb) {
  return tt.offUnhandledRejection(cb);
});

var bytedanceModule = {
  getApp: getApp$5,
  getCurrentPages: getCurrentPages$4,
  getLaunchOptionsSync: getLaunchOptionsSync$4,
  onError: onError$4,
  offError: offError$3,
  onUnhandledRejection: onUnhandledRejection$4,
  offUnhandledRejection: offUnhandledRejection$3
};

var getApp$4 = (function () {
  return window;
});

var getCurrentPages$3 = (function () {
  var query = {};
  var hash = {};
  window.location.hash.replace(/#.*?\?/, '').split('&').forEach(function (i) {
    hash[i.split('=')[0]] = i.split('=')[1];
  });
  window.location.search.replace('?', '').split('&').forEach(function (i) {
    query[i.split('=')[0]] = i.split('=')[1];
  });
  return [{
    pageId: "" + window.location.pathname + window.location.hash + "-1",
    query: query,
    hash: hash
  }];
});

var getLaunchOptionsSync$3 = (function () {
  return {
    path: window.location.pathname,
    query: {}
  };
});

var onError$3 = (function (cb) {
  return window.addEventListener('error', cb);
});

var offError$2 = (function (cb) {
  return window.removeEventListener('error', cb);
});

var onUnhandledRejection$3 = (function (cb) {
  return window.addEventListener('unhandledrejection', cb);
});

var offUnhandledRejection$2 = (function (cb) {
  return window.removeEventListener('unhandledrejection', cb);
});

var webModule = {
  getApp: getApp$4,
  getCurrentPages: getCurrentPages$3,
  getLaunchOptionsSync: getLaunchOptionsSync$3,
  onError: onError$3,
  offError: offError$2,
  onUnhandledRejection: onUnhandledRejection$3,
  offUnhandledRejection: offUnhandledRejection$2
};

var getApp$3 = (function () {
  return getApp();
});

var getCurrentPages$2 = (function () {
  return getCurrentPages();
});

var getLaunchOptionsSync$2 = (function () {
  return ks.getLaunchOptionsSync();
});

var onError$2 = (function (cb) {
  return ks.onError(cb);
});

var offError$1 = (function (cb) {
  return ks.offError(cb);
});

var onUnhandledRejection$2 = (function (cb) {
  return ks.onUnhandledRejection(cb);
});

var offUnhandledRejection$1 = (function (cb) {
  return ks.offUnhandledRejection(cb);
});

var kuaiShouModule = {
  getApp: getApp$3,
  getCurrentPages: getCurrentPages$2,
  getLaunchOptionsSync: getLaunchOptionsSync$2,
  onError: onError$2,
  offError: offError$1,
  onUnhandledRejection: onUnhandledRejection$2,
  offUnhandledRejection: offUnhandledRejection$1
};

var getApp$2 = (function () {
  return getApp();
});

var getCurrentPages$1 = (function () {
  return getCurrentPages();
});

// export default () => swan.getLaunchOptionsSync();
var getLaunchOptionsSync$1 = (function () {});

var onError$1 = (function (cb) {
  return swan.onError(cb);
});

var offError = (function (cb) {
  return swan.offError(cb);
});

var onUnhandledRejection$1 = (function (cb) {// return swan.onUnhandledRejection(cb);
});

var offUnhandledRejection = (function (cb) {// return swan.offUnhandledRejection(cb);
});

var baiDuModule = {
  getApp: getApp$2,
  getCurrentPages: getCurrentPages$1,
  getLaunchOptionsSync: getLaunchOptionsSync$1,
  onError: onError$1,
  offError: offError,
  onUnhandledRejection: onUnhandledRejection$1,
  offUnhandledRejection: offUnhandledRejection
};

var getApp$1 = function getApp() {
  if (isWeb) {
    return webModule.getApp();
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.getApp();
  } else if (isWeChatMiniProgram) {
    return weChatModule.getApp();
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.getApp();
  } else if (isMiniApp) {
    return aliMiniAppModule.getApp();
  } else if (isBaiduSmartProgram) {
    return baiDuModule.getApp();
  } else {
    throw new Error('@uni：application.getApp 暂不支持');
  }
};
var getLaunchOptionsSync = function getLaunchOptionsSync() {
  if (isWeb) {
    return webModule.getLaunchOptionsSync();
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.getLaunchOptionsSync();
  } else if (isWeChatMiniProgram) {
    return weChatModule.getLaunchOptionsSync();
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.getLaunchOptionsSync();
  } else if (isMiniApp) {
    return aliMiniAppModule.getLaunchOptionsSync();
  } else {
    throw new Error('@uni：application.getLaunchOptionsSync 暂不支持');
  }
};
var onError = function onError(options) {
  if (isWeb) {
    return webModule.onError(options);
  } else if (isKuaiShouMiniProgram) {
    throw new Error('@uni：onError 暂不支持');
  } else if (isWeChatMiniProgram) {
    return weChatModule.onError(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.onError(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.onError(options);
  } else if (isBaiduSmartProgram) {
    return baiDuModule.onError(options);
  } else {
    throw new Error('@uni：onError 暂不支持');
  }
};
var onUnhandledRejection = function onUnhandledRejection(options) {
  if (isWeb) {
    return webModule.onUnhandledRejection(options);
  } else if (isKuaiShouMiniProgram) {
    return kuaiShouModule.onUnhandledRejection(options);
  } else if (isWeChatMiniProgram) {
    return weChatModule.onUnhandledRejection(options);
  } else if (isByteDanceMicroApp) {
    return bytedanceModule.onUnhandledRejection(options);
  } else if (isMiniApp) {
    return aliMiniAppModule.onUnhandledRejection(options);
  } else {
    throw new Error('@uni：onUnhandledRejection 暂不支持');
  }
};

export { onUnhandledRejection as a, getLaunchOptionsSync as b, getApp$1 as g, onError as o };
